<template>
    <div id="orderLabel">
        <el-row>
            <el-col :span='4'><span>制单人:</span></el-col>
            <el-col :span='4'><span>{{users.createUser}}</span></el-col>
            <el-col :span='4' :offset="4"><span>业务员:</span></el-col>
            <el-col :span='4'><span>{{users.salesman}}</span></el-col>
        </el-row>
        <table border="1" cellspacing="0" style="width: 100%" >
            <tr>
                <th colspan="2" style="width: 300px">订单</th>
                <th colspan="2" style="width: 300px">标签</th>
            </tr>
            <tr>
                <td style="width: 115px">订单类别</td>
                <td>
                    <span v-if="order.orderType=='A'">正常订单</span>
                    <span v-if="order.orderType=='B'">打样</span>
                    <span v-if="order.orderType=='C'">赠送</span>
                    <span v-if="order.orderType=='D'">其他</span>
                </td>
                <td style="width: 115px">标签原材料</td>
                <td>{{label.material}}</td>
            </tr>
            <tr>
                <td>交货日期</td>
                <td>{{order.deliveryTime}}</td>
                <td>刀具信息</td>
                <td> <span v-if="label.cut">切刀 </span>
                    <span v-if="label.dashed">虚刀</span>
                    <span v-if='label.cut!=true&&label.dashed!=true'>无</span></td>
            </tr>
            <tr>
                <td>包装要求</td>
                <td>{{order.packing}}</td>
                <td>标签长</td>
                <td>{{label.lbLength}} mm</td>
            </tr>
            <tr>
                <td>加工类别</td>
                <td v-if="order.type=='P'">印刷</td>
                <td v-if="order.type=='C'">模切</td>
                <td>标签高</td>
                <td>{{label.lbWidth}} mm</td>
            </tr>
            <tr>
                <td>订单数量（卷）</td>
                <td>{{order.quantity}}</td>
                <td>角形R</td>
                <td>{{label.angle}} mm</td>
            </tr>
            <tr>
                <td>卷/箱</td>
                <td>{{order.rollOfPacking}}</td>
                <td>圆孔内径</td>
                <td>{{label.hole}} mm</td>
            </tr>
            <tr>
                <td>对稿方式</td>
                <td v-if="order.compare=='S'">样品</td>
                <td v-if="order.compare=='B'">黑稿</td>
                <td v-if="order.compare=='N'">无</td>
                <td>上下间距</td>
                <td>{{label.vSpacing}} mm</td>

            </tr>
            <tr>
                <td>PCS/卷</td>
                <td>{{order.numberOfRoll}}</td>
                <td>左右间距</td>
                <td>{{label.hSpacing}} mm</td>
            </tr>
            <tr>
                <td>印刷内容</td>
                <td>{{order.printInfo}}</td>
                <td>标签排数</td>
                <td>{{label.row}} 排</td>
            </tr>
            <tr>
                <td>内卷/外卷</td>
                <td v-if="order.roll=='O'">外卷</td>
                <td v-if="order.roll=='I'">内卷</td>
                <td>左边距</td>
                <td>{{label.leftBorderMin}} mm ~ {{label.leftBorderMax}} mm</td>
            </tr>
            <tr>
                <td>成品纸芯内径</td>
                <td>{{order.paperElementD}} mm</td>
                <td>右边距</td>
                <td>{{label.rightBorderMin}} mm ~ {{label.rightBorderMax}} mm</td>
            </tr>
            <tr>
                <td>颜色参照</td>
                <td v-if="order.color=='S'">样品</td>
                <td v-if="order.color=='P'">彩稿</td>
                <td v-if="order.color=='C'">电脑</td>
                <td v-if="order.color=='O'">其他</td>
                <td>客户</td>
                <td>*</td>                
                <!-- <td>{{label.customer}}</td>                 -->
            </tr>
            <tr>
                <td>出标方向</td>
                <td v-if="order.orientation=='N'">无</td>
                <td v-if="order.orientation=='M'">按图上箭头标注为准</td>
                <td>附件</td>
                <td>
                    <el-button v-if="files.pic!=''||files.zip!==''" type="text" @click="visible=true">查看附件</el-button>
                    <span v-else>无</span>
                </td>
                <!-- <td>备注</td>
                <td v-if="order.remark!=''" colspan="3">
                    <textarea cols="30" rows="3" readonly style="font-size:15px; color:red; width:98%;">{{order.remark}}</textarea>
                </td>
                <td v-else colspan="3">无</td> -->
            </tr>
            <tr>
                <td>备注</td>
                <td colspan="3">
                    <textarea v-if="order.remark!=''" cols="30" rows="3" readonly style="font-size:15px; color:red; width:98%;">{{order.remark}}</textarea>
                    <span v-else>无</span>
                </td>
            </tr>
        </table>

        <el-dialog title="附件信息" :visible.sync="visible" :close-on-click-modal="false" width="300px">
            <!-- 附件信息 -->
            <Attachment :attachmentInfo='files' :orderId='order.id'></Attachment>
        </el-dialog>
    </div>
</template>
<script>
import Attachment from "@/components/production/Attachment";

export default {
  components: {
    Attachment
  },
  data: function() {
    return {
      visible: false,
    };
  },
  props: {
    order: {},
    label: {},
    files: {},
    users: {},
    disabled: Boolean
  }
};
</script>





// WEBPACK FOOTER //
// src/components/production/OrderLabel.vue